import { GridColumnType } from "../../../data/gridColumnType";

export const SGBSCategoryCriteriaConfig = {
  columns: [
    {
      name: "Category (L1)",
      fieldName: "category",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Sub Category (L2)",
      fieldName: "subCategory",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Type (L3)",
      fieldName: "type",
      colType: GridColumnType.Text,
    },
    {
      name: "Criteria Name",
      fieldName: "criteriaName",
      colType: GridColumnType.Text,
    },
    {
      name: "Certificate",
      fieldName: "certificate",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "Edit",
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
